// Copyright (c) 2016 Deere & Company

import ClaimAction, {getDefaultState as getClaimActionDefaultState} from './claim-action';
import ClaimRecordInfo, {getDefaultState as getClaimClaimRecordInfoDefaultState} from './claim-record-info';
import ClaimReimbursementDetails, {getDefaultState as getClaimReimbursementDetailsDefaultState} from './claim-reimbursement-details';
import ClaimRgaStatus, {getDefaultState as getClaimRgaStatusDefaultState} from './claim-rga-status';
import ClaimRules, {getDefaultState as getClaimRulesDefaultState} from './claim-rules';
import ClaimValueDetails, {getDefaultState as getClaimValueDetailsDefaultState} from './claim-value-details';
import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import PdiPin, {getDefaultState as getPdiPinDefaultState} from './pdi-pin';
import ClaimMarketingReferenceInfo from './claim-marketing-reference-info';
import ClaimVsrMessage from './claim-vsr-message';
import File from './file';
import t from 'tcomb';

const ClaimMassChannelPdi = t.struct({
    allowedActions: t.list(ClaimAction, 'AllowedActions'),
    approvalDate: t.maybe(t.Number),
    claimNumber: t.String,
    claimStatus: KeyValuePair,
    claimType: KeyValuePair,
    claimValueDetails: ClaimValueDetails,
    errors: t.list(ClaimVsrMessage, 'Errors'),
    file: t.maybe(t.list(File, 'Files')),
    goodsInstallationVat: t.maybe(KeyValuePair),
    hideClaimValueDetails: t.Bool,
    isDuplicateClaim: t.Bool,
    isEditable: t.Bool,
    pins: t.list(PdiPin, 'PINs'),
    purchaseOrderNumber: t.String,
    recordInfo: ClaimRecordInfo,
    referenceInfo: ClaimMarketingReferenceInfo,
    reimbursementDetails: ClaimReimbursementDetails,
    responsibleAccount: Dealer,
    retailerName: KeyValuePair,
    rgaStatus: ClaimRgaStatus,
    rules: ClaimRules,
    selectedAction: ClaimAction,
    setupDate: t.maybe(t.Number),
    showAmountsInLocalCurrency: t.Bool,
    showGoodsInstallationVat: t.Bool,
    storeNumber: t.String,
    subClaimType: KeyValuePair,
    validationFailed: t.Bool,
    version: t.String
}, {
    name: 'ClaimMassChannelPdi',
    strict: true
});

export const getDefaultState = () => new ClaimMassChannelPdi({
    allowedActions: [
        new ClaimAction({
            actionName: 'SAVE_VALD',
            id: 'SAVE_VALD',
            mode: 'CHG'
        })
    ],
    approvalDate: null,
    claimNumber: '',
    claimStatus: getKeyValuePairDefaultState(),
    claimType: new KeyValuePair({
        key: 'ZZMK',
        value: ''
    }),
    claimValueDetails: getClaimValueDetailsDefaultState(),
    errors: [],
    file: [],
    goodsInstallationVat: getKeyValuePairDefaultState(),
    hideClaimValueDetails: true,
    isDuplicateClaim: false,
    isEditable: true,
    pins: [
        getPdiPinDefaultState(),
        getPdiPinDefaultState(),
        getPdiPinDefaultState(),
        getPdiPinDefaultState(),
        getPdiPinDefaultState(),
        getPdiPinDefaultState()
    ],
    purchaseOrderNumber: '',
    recordInfo: getClaimClaimRecordInfoDefaultState(),
    referenceInfo: new ClaimMarketingReferenceInfo({
        referenceNumber1: '',
        referenceNumber2: '',
        referenceNumber3: ''
    }),
    reimbursementDetails: getClaimReimbursementDetailsDefaultState(),
    responsibleAccount: getDealerDefaultState(),
    retailerName: getKeyValuePairDefaultState(),
    rgaStatus: getClaimRgaStatusDefaultState(),
    rules: getClaimRulesDefaultState(),
    selectedAction: getClaimActionDefaultState(),
    setupDate: null,
    showAmountsInLocalCurrency: false,
    showGoodsInstallationVat: false,
    storeNumber: '',
    subClaimType: new KeyValuePair({
        key: 'PDI',
        value: ''
    }),
    validationFailed: false,
    version: ''
});

ClaimMassChannelPdi.prototype.vsrErrorMessages = function vsrErrorMessages() {

    const errorMessages = this.errors.filter(vsrMessage => vsrMessage.type.key === 'E');

    return errorMessages;

};

ClaimMassChannelPdi.prototype.vsrWarningMessages = function vsrWarningMessages() {

    const errorMessages = this.errors.filter(vsrMessage => vsrMessage.type.key === 'W');

    return errorMessages;

};

ClaimMassChannelPdi.prototype.vsrInfoMessages = function vsrInfoMessages() {

    const errorMessages = this.errors.filter(vsrMessage => vsrMessage.type.key === 'I');

    return errorMessages;

};

export default ClaimMassChannelPdi;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-mass-channel-pdi.js